import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useWorkflowOverviewSearch = defineStore(
  'workflowOverviewSearch',
  () => {
    const focusedAt = ref<number | undefined>(undefined)
    const searchTerm = ref('')

    function focusSearch(): void {
      focusedAt.value = Date.now()
    }

    function clearSearch(): void {
      searchTerm.value = ''
    }

    function searchFor(term: string): void {
      searchTerm.value = term
    }

    return {
      clearSearch,
      focusedAt,
      focusSearch,
      searchFor,
      searchTerm,
    }
  }
)
